import { Route } from '@angular/router';

export const shellsRoutes: Route[] = [
  {
    path: 'shells/catalog-parts',
    loadComponent: () =>
      import('./shell-list/catalog-parts/catalog-parts.component').then(
        (m) => m.CatalogPartsComponent
      ),
  },
  {
    path: 'shells/part-instances',
    loadComponent: () =>
      import('./shell-list/part-instances/part-instances.component').then(
        (m) => m.PartInstancesComponent
      ),
  },
  {
    path: 'shell-details/:globalId',
    loadComponent: () =>
      import('./shell-detail/shell-detail.component').then(
        (m) => m.ShellDetailComponent
      ),
  },
];
